const key = "NcasReportingBookmarks";
export default {
    IsBookmarked: (path) => {
        let marks = JSON.parse(localStorage.getItem(key));

        if (marks === null) {
            return false;
        }

        let mark = marks.findIndex(m => m.path.toLowerCase() === path.toLowerCase());

        if (mark === undefined || mark === null || mark === -1) {
            return false;
        } else {
            return true;
        }
    },
    CreateBookmark: (path, displayName, dateAdded) => {
        let marks = JSON.parse(localStorage.getItem(key));

        if (marks === null) {
            marks = [];
        }

        marks.push({
            path: path,
            displayName: displayName,
            dateAdded: dateAdded
        });

        localStorage.setItem(key, JSON.stringify(marks));
    }, 
    RemoveBookmark: (path) => {
        let marks = JSON.parse(localStorage.getItem(key));

        if (marks === null) {
            return false;
        }

        let index = marks.findIndex(m => m.path.toLowerCase() === path.toLowerCase());

        marks.splice(index, 1);

        localStorage.setItem(key, JSON.stringify(marks));
    },
    GetBookmarks: () => {
        let marks = JSON.parse(localStorage.getItem(key));

        if (marks === null) {
            marks = [];
        }

        return marks;
    },
    EventName: "UpdateBookmarks"
};